import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { Model } from '@core/shared/model';
import { BehaviorSubject } from 'rxjs';
import { BaseFormService, FsOnUpdateFormControlReadonlyStateEvent } from '../form-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { objectCloneDeep } from '@core/shared/utils';
export class ArrayFormService extends BaseFormService {
  constructor() {
    super(...arguments);
    // TODO: should there really be service.value AND formGroup.value?
    this.value = [];
    // will emit if the structure of the FormArray controls changes, useful for fieldset rendering
    this._onFormArrayUpdated$ = new BehaviorSubject(null);
    this.onFormArrayUpdated$ = this._onFormArrayUpdated$.pipe(takeUntilDestroyed(this.destroyRef));
  }
  // ###########################################################################################################
  // ####  SETUP  ##############################################################################################
  // ###########################################################################################################
  initialize() {
    var _superprop_getInitialize = () => super.initialize,
      _this = this;
    return _asyncToGenerator(function* () {
      const status = yield _superprop_getInitialize().call(_this);
      if (status) _this._onFormArrayUpdated$.next(_this.formGroup);
      return status;
    })();
  }
  // ###########################################################################################################
  // ####  VALUE HANDLING  #####################################################################################
  // ###########################################################################################################
  reloadFormValue(value, options = {}) {
    if (!this.formGroup) return;
    if (this._debug) console.log(this.debugInfo() + '.reloadFormValue', this.formGroup.value, value);
    this.formGroup.setValue(value, options, true);
    this.refreshFormState();
  }
  getValue() {
    if (!this.formGroup) return null;
    let value = this.formGroup.getRawValue();
    if (!Array.isArray(value)) throw new Error('ArrayFormService.getValue can only work with arrays!');
    if (this.immutableValues) {
      value = value.map(item => {
        return {
          ...item,
          ...this.immutableValues
        };
      });
    }
    if (this.modelFactory?.Model) {
      value = value.map(item => this.modelFactory.fromData(item));
    }
    return value;
  }
  _setValue(inputValue, options = {}) {
    if (this._debug) console.log(this.debugInfo() + '._setValue', inputValue);
    if (!Array.isArray(inputValue)) throw new Error('ArrayFormService._setValue can only work with arrays!');
    if (!this.modelFactory) throw new Error('Cannot create valid internal value because modelFactory is missing!');
    const value = inputValue.map(item => {
      if (!(item instanceof Model) && !this.modelFactory) {
        throw new Error('ArrayFormService._setValue cannot be used with non-models if no modelFactory is set!');
      }
      // try to convert values to correct model
      if (!(inputValue instanceof this.modelFactory.Model)) {
        return this.modelFactory.fromData({
          ...inputValue,
          ...this.immutableValues
        });
      } else {
        return this.modelFactory.patch(inputValue, this.immutableValues);
      }
    });
    this.reloadFormValue(value, options);
  }
  setValue(value, options = {}) {
    if (!Array.isArray(value)) throw new Error('ArrayFormService: trying to set non-array value');
    value = objectCloneDeep(value);
    this.reloadFormValue(value, options);
  }
  getDefaultValue() {
    return [];
  }
  getInitialValue() {
    return [];
  }
  dataIsArray() {
    return true;
  }
  // ###########################################################################################################
  // ####  FORM ARRAY  #########################################################################################
  // ###########################################################################################################
  buildFormGroup() {
    if (this._debug) console.log(this.debugInfo() + '.buildFormGroup', this.formGroup, this.modelFactory);
    if (!this.modelFactory) return Promise.reject('buildFormGroup error: exposedModelFactory not available');
    if (!this.formGroup) {
      throw new Error('no formGroup set for ArrayFormSerice, aborting.');
      // const fg = this.enhanceFormGroup(new UntypedFormArray([]));
      // this.formGroup$.next(fg); 
    }
    return this.resolveFormDependencies().then(() => {
      // ngxDynamicFormBuilder requires root form to have dynamicFormBuilderOptions, else setObject will fail.
      if (!this.formGroup.root.dynamicFormBuilderOptions) {
        const dummyForm = this.createDynamicFormGroup({});
        this.formGroup.root.dynamicFormBuilderOptions = dummyForm.dynamicFormBuilderOptions;
      }
      // this.formGroup.reset(); // would reset state but value too!
      this.formGroup.markAsPristine();
      this.formGroup.markAsUntouched();
      this.bindFormGroupListeners();
      // now that formGroup is ready, this will trigger controls$ emission
      // which is required to make UI show the actual form data.
      this.formGroup.updateValueAndValidity();
    });
  }
  updateFormControlDisabledState() {
    if (!this.formGroup) return;
    this.events$.next(new FsOnUpdateFormControlReadonlyStateEvent(this.formGroup));
  }
  addNewItem() {
    const data = this.modelFactory.newInstance();
    this.formGroup.addItem(data);
    // const newItem = createformArrayChildFormGroup(data, this.formGroup as any);
    // this.formGroup.push(newItem)
    // newItem.markAsPristine();
    // newItem.markAsUntouched();
    // attach validation logic + current status for the new formGroup.
    // this.refreshFormState();
    this._onFormArrayUpdated$.next(this.formGroup);
  }
  removeItem(input) {
    const index = typeof input === 'number' ? input : this.formGroup.controls.findIndex(i2 => i2 === input);
    this.formGroup.removeAt(index);
    this._onFormArrayUpdated$.next(this.formGroup);
  }
  reorderItems(actions) {
    let tmp;
    actions.forEach(action => {
      tmp = this.formGroup.at(action.from);
      this.formGroup.removeAt(action.from);
      this.formGroup.insert(action.to, tmp);
    });
    this._onFormArrayUpdated$.next(this.formGroup);
  }
}